import { render, staticRenderFns } from "./ver-motivo.vue?vue&type=template&id=680e9260"
import script from "./ver-motivo.vue?vue&type=script&lang=js"
export * from "./ver-motivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports